import React from 'react';
import TableCell from './TableCell';
import { ITableRowProps } from './Interfaces';

const TableRow: React.FC<ITableRowProps> = ({ rowData, rowIndex, refreshNr, serverErrors, colInfos, colUserSettings, onRowClick, onCellChange, onSelectedRowsChange }) => {

    function rowClick(args: any) {
        if (onRowClick)
            onRowClick(rowData)
    }

    let tableCells = colInfos.map(function (colInfo, colIndex) {
        return (<TableCell key={refreshNr + '-' + rowIndex + '-' + colIndex} colInfo={colInfo} colUserSettings={colUserSettings[colIndex]} colIndex={colIndex} rowIndex={rowIndex} refreshNr={refreshNr} rowData={rowData} onRowClick={rowClick} onCellChange={onCellChange} serverErrors={serverErrors} onSelectedRowsChange={onSelectedRowsChange} />);
    });

    return (<tr>{tableCells}</tr>);
}
export default TableRow;